module.exports = __webpack_public_path__ + "static/post-492ad525905e73bd80839df142f8d1cc.png";